import { ColorTypes } from "@omegagrid/core";
import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions } from "@reporting/rp-app-host";
import { StatementDefinition, StatementRowAcct } from "@reporting/rp-types/definition";

const PAGE_SIZE = 500;

export class FinAccountsGridAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(
		private statement: StatementDefinition = null
	) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'id_account',
			header: '#',
			t: 't',
			e: false,
			w: 100,
			filter: true,
		}, {
			data: 'account',
			header: msg('Account'),
			t: 't',
			e: false,
			w: 400,
			filter: true,
		}, {
			data: 'property_1',
			header: msg('Attributes'),
			t: 't',
			e: false,
			w: 100
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const accounts = await rp.ms('definition').get<StatementRowAcct[]>(`/statementAccounts`, this.createRequestParams(filters, {
			idStatement: this.statement?.id_statement ?? null,
			count: PAGE_SIZE,
			accounting: this.statement?.accounting ?? rp.accountingProvider.a,
		}));
		return accounts.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			rowNumbers: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			toolbar: {
				refresh: {
					text: msg('Refresh'),
					color: ColorTypes.Gray,
					icon: 'arrows-rotate',
					enabled: true
				},
				save: {enabled: false},
				discard: {enabled: false},
				new: {enabled: false},
			},
		});
	}
}
